import { IDefineCommand, IQuery } from 'core-ts-types';
import { ContactInformationModel } from '../models/contact_information_model';
import { ConfirmationNumberService } from '../services/confirmation_number_service';

angular
  .module('capability-ng-notification-settings')
  .factory(
    'updateConfirmationNumberCommand',
    function updateConfirmationNumberCommandDefinition(
      defineCommand: IDefineCommand,
      ngConfirmationNumberService: ConfirmationNumberService,
      contactInformationModel: ContactInformationModel,
      $http: ng.IHttpService
    ) {
      return defineCommand(
        'updateConfirmationNumberCommand',
        function updateConfirmationNumberCommand(deferred: ng.IDeferred<IQuery[]>, number: string) {
          number = ngConfirmationNumberService.sanitizeConfirmationNumber(number);
          if (!number) {
            deferred.reject({
              detail: 'Not a valid code'
            });
            return;
          }
          $http
            .post('notification/student/channels/verify/', {
              channel: 'phone',
              code: number
            })
            .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
              deferred.resolve(contactInformationModel.isVerifiedNumberFromServer(data));
            })
            .catch(({ data }) => {
              deferred.reject(data);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-notification-settings/src/commands/update_confirmation_number_command.ts